export class DefaultValidationRenderer {
    render(instruction) {

        for (let { error, elements } of instruction.unrender) {
            for (let element of elements) {
                this.remove(element, error);
            }
        }

        for (let { error, elements } of instruction.render) {
            for (let element of elements) {
                this.add(element, error);
            }
        }
    }

    add(element, error) {


        var ddcl = element.closest("dropdown-checklist");
        if (ddcl) {
            ddcl.querySelector(".dropdown").classList.add('has-error');
        }


        const formGroup = element.querySelector('.control-group') || element.closest(".control-group") || element.querySelector('.form-group') || element.closest(".form-group");
        if (!formGroup) {
            return;
        }
        // add the has-error class to the enclosing form-group div
        formGroup.classList.add('has-error');

        // for control-groups, add error to preceding label, if any
        if (formGroup.previousElementSibling && formGroup.previousElementSibling.tagName == "LABEL") {
            formGroup.previousElementSibling.classList.add('has-error');
        }
        // add help-block
        // const message = document.createElement('span');
        // message.className = 'help-block validation-message';
        // message.textContent = error.message;
        // message.id = `validation-message-${error.id}`;
        // formGroup.appendChild(message);

        var errorPart = formGroup.querySelector(".error-part");
        if (errorPart) {
            errorPart.style.display = "block";

            var errorLabel = errorPart.querySelector(".error-label");
            if (errorPart) {
                errorLabel.innerText = error.message;
            }
        }
    }

    remove(element, error) {


        var ddcl = element.closest("dropdown-checklist");
        if (ddcl) {
            ddcl.querySelector(".dropdown").classList.remove('has-error');

        }
        const formGroup = element.querySelector('.control-group') || element.closest(".control-group") || element.querySelector('.form-group') || element.closest(".form-group");
        if (!formGroup) {
            return;
        }

        // for control-groups, remove error from preceding label, if any
        if (formGroup.previousElementSibling && formGroup.previousElementSibling.tagName == "LABEL") {
            formGroup.previousElementSibling.classList.remove('has-error');
        }

        // // remove help-block
        // const message = formGroup.querySelector(`#validation-message-${error.id}`);
        // if (message) {
        //   formGroup.removeChild(message);

        // remove the has-error class from the enclosing form-group div
        if (formGroup.querySelectorAll('.help-block.validation-message').length === 0) {
            formGroup.classList.remove('has-error');
        }


        var errorPart = formGroup.querySelector(".error-part");
        if (errorPart) {
            errorPart.style.display = "none";

            var errorLabel = errorPart.querySelector(".error-label");
            if (errorPart) {
                errorLabel.innerText = "";
            }
        }

    }
}